import { IApiQueryFunction, createApiQueryHook } from "../../utils/api";
import { RelationalValue, mapRelationalValue } from "../../utils/filters";
import { IUser, IUserResource } from "../types";

export interface IUserQueryParameters {
    user?: RelationalValue<IUserResource>;
}

export type IUserQueryResult = IUser;

export const userQuery: IApiQueryFunction<IUserQueryParameters> = ({ user }) => {
    if (!user) {
        return;
    }

    return {
        method: "GET",
        url: `/users/${mapRelationalValue(user)}`,
    };
};

export const useUserQuery = createApiQueryHook<IUserQueryParameters, IUserQueryResult>(userQuery);
